import { render } from "./transctionspage.vue?vue&type=template&id=1b7b084a&scoped=true"
import script from "./transctionspage.vue?vue&type=script&lang=js"
export * from "./transctionspage.vue?vue&type=script&lang=js"

import "./transctionspage.vue?vue&type=style&index=0&id=1b7b084a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7b084a"]])

export default __exports__